import Axios from 'axios'

function getEndpointsPromise () {
  return Axios.get('/api/endpoints')
}

export default {
  getEndpointsPromise
}
